import m from "mithril";
import Landing from "./views/Landing.js?v=6";

// Vulgar lazy-loaded
// ToastTest lazy-loaded
// HashTool lazy-loaded
// LocalStorageReader lazy-loaded
import Layout from "./views/Layout.js?v=7";
import ExpiryStorage from "./js/expiryStorage.js";
import { getUserData } from "./utils.js";
// UnitBusiness lazy-loaded
// UnitUsaha lazy-loaded
import BadanDanUnitUsaha from "./views/BadanDanUnitUsaha.js";
import Login from "./views/Login.js?v=10"; // Force cache refresh
import ForgotPassword from "./views/ForgotPassword.js";
import ResetPassword from "./views/ResetPassword.js";
// Unauthorized lazy-loaded
// Import new views
import Officers from "./views/Officers.js";
import Produk from "./views/Produk.js";
// Import new loan views
import LoanMining from './views/LoanMining.js'; // Add LoanMining import
// Import new savings views
import SavingsDeposits from "./views/SavingsDeposits.js";
import SavingsInterestPayment from "./views/SavingsInterestPayment.js";
import SavingsPerformance from "./views/SavingsPerformance.js";
import SavingsDepositsCoordinator from "./views/SavingsDepositsCoordinator.js";
import DaftarSimpanan from "./views/DaftarSimpanan.js";
import DaftarPinjaman from "./views/DaftarPinjaman.js";
import LoanPrediction from "./views/LoanPrediction.js";
import Receipts from "./views/Receipts.js";
import AccountList from "./views/AccountList.js";
import EditAccount from "./views/EditAccount.js";
import ViewAccount from "./views/ViewAccount.js";
// Import CoordCustomers for koordinator role
import CoordCustomers from "./views/CoordCustomers.js";
import CoordViewCustomer from "./views/CoordViewCustomer.js";
import CoordCustomersMobile from "./views/CoordCustomers-mobile.js";
import CoordMobileRekapPinjamanDetails from "./views/CoordMobileRekapPinjamanDetails.js";
import CoordMobileRekapSimpananHistory from "./views/CoordMobileRekapSimpananHistory.js";
import CoordHomeMobile from "./views/CoordHomeMobile.js";
// Import coordinator management views for managers
import CoordinatorAktivitas from "./views/CoordinatorAktivitas.js";
import CoordinatorSetoran from "./views/CoordinatorSetoran.js";
import CoordinatorFundManagement from "./views/CoordinatorFundManagement.js";
import KasirDashboard from "./views/KasirDashboard.js";
import BankDepositHistory from "./views/BankDepositHistory.js";
import NomenclatureSettings from "./views/NomenclatureSettings.js";
import Backup from "./views/Backup.js";
import SubunitBackup from "./views/SubunitBackup.js";
import LoansPerformance from "./views/LoansPerformance.js";
import KinerjaTarget from "./views/KinerjaTarget.js";
import KinerjaRealisasi from "./views/KinerjaRealisasi.js";

// Accounting Module Imports
import AkuntansiDashboard from "./views/AkuntansiDashboard.js";
import PostingJurnal from "./views/accounting/PostingJurnal.js";
import EquityChange from "./views/accounting/reports/EquityChange.js";
import CashFlow from "./views/accounting/reports/CashFlow.js";
import CALK from "./views/accounting/reports/CALK.js";

// DbTool lazy-loaded

const lazyView = (loader) => {
    const resolver = async () => (await loader()).default;
    resolver.__lazy = true;
    return resolver;
};

const resolveViewComponent = async (viewComponent) => {
    if (typeof viewComponent === "function" && viewComponent.__lazy) {
        return await viewComponent();
    }
    return viewComponent;
};

const Customers = lazyView(() => import("./views/Customers.js"));
const Kelompok = lazyView(() => import("./views/Kelompok.js"));
const Branches = lazyView(() => import("./views/Branches.js"));
const Dashboard = lazyView(() => import("./views/Dashboard.js"));
const Profile = lazyView(() => import("./views/Profile.js"));
const LoanSubmissions = lazyView(() => import("./views/LoanSubmissions.js"));
const LoanApprovals = lazyView(() => import("./views/LoanApprovals.js"));
const LoanDisbursements = lazyView(() => import("./views/LoanDisbursements.js"));
const LoanInstallments = lazyView(() => import("./views/LoanInstallments.js"));
const LoanSettlements = lazyView(() => import("./views/LoanSettlements.js"));
const SavingsWithdrawals = lazyView(() => import("./views/SavingsWithdrawals.js"));
const NewAccount = lazyView(() => import("./views/NewAccount.js"));
const Belanja = lazyView(() => import("./views/Belanja.js"));
const GeneralJournal = lazyView(() => import("./views/accounting/GeneralJournal.js"));
const BalanceSheet = lazyView(() => import("./views/accounting/reports/BalanceSheet.js"));
const IncomeStatement = lazyView(() => import("./views/accounting/reports/IncomeStatement.js"));
const PerhitunganPHU = lazyView(() => import("./views/accounting/reports/PerhitunganPHU.js"));
const CoordAddCustomerMobile = lazyView(() => import("./views/CoordAddCustomerMobile.js"));
const CoordEditCustomerMobile = lazyView(() => import("./views/CoordEditCustomerMobile.js"));
const CoordDashboardMobile = lazyView(() => import("./views/Coord-dashboard-mobile.js"));
const CoordSavingAccountMobile = lazyView(() => import("./views/Coord-saving-account-mobile.js"));
const CoordLoanInstallmentMobile = lazyView(() => import("./views/Coord-loan-installment-mobile.js"));
const CoordReceiptsMobile = lazyView(() => import("./views/Coord-receipts-mobile.js"));
const CoordViewCustomerMobile = lazyView(() => import("./views/Coord-view-customer-mobile.js"));
const CoordPinjamanMobile = lazyView(() => import("./views/CoordPinjamanMobile.js"));
const CoordPengajuanMobile = lazyView(() => import("./views/CoordPengajuanMobile.js"));
const CoordPencairanMobile = lazyView(() => import("./views/CoordPencairanMobile.js"));
const CoordLoanSettlementsMobile = lazyView(() => import("./views/CoordLoanSettlementsMobile.js"));
const CoordMobileRekapitulasi = lazyView(() => import("./views/CoordMobileRekapitulasi.js"));
const CoordMobileRekapPinjaman = lazyView(() => import("./views/CoordMobileRekapPinjaman.js"));
const CoordMobileRekapSimpanan = lazyView(() => import("./views/CoordMobileRekapSimpanan.js"));
const CoordSavingsWithdrawals = lazyView(() => import("./views/CoordSavingsWithdrawals.js"));
 const CoordProfileMobile = lazyView(() => import("./views/CoordProfileMobile.js"));
 const CoordCustomerPortfolioDetailMobile = lazyView(() => import("./views/CoordCustomerPortfolioDetailMobile.js"));
 const CoordCustomerProfileMobile = lazyView(() => import("./views/CoordCustomerProfileMobile.js"));
 const LoanInstallmentsCoordinator = lazyView(() => import("./views/LoanInstallmentsCoordinator.js"));
 const LoanMonitoring = lazyView(() => import("./views/LoanMonitoring.js"));

// Device detection utility
const detectDevice = () => {
    // Method 1: User Agent string detection
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

    // Method 2: Screen size detection
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const isSmallScreen = Math.min(screenWidth, screenHeight) < 768; // Common mobile breakpoint

    // Method 3: Touch capability detection
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Method 4: Pointer events (more modern)
    const hasCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

    // Comprehensive detection (combine multiple methods for accuracy)
    const isMobile = isMobileUA || isSmallScreen || hasTouch || hasCoarsePointer;

    // Additional device info
    const isTablet = isMobile && Math.min(screenWidth, screenHeight) >= 768;
    const isDesktop = !isMobile;

    // Method 5: PWA Standalone detection
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                        navigator.standalone === true ||
                        window.navigator.standalone === true;

    return {
        isMobile,
        isTablet,
        isDesktop,
        isStandalone,
        screenWidth,
        screenHeight,
        userAgent,
        hasTouch,
        platform: navigator.platform
    };
};

// Make device detection globally available
window.deviceInfo = detectDevice();

// Log device info for debugging
console.log('Device Detection:', window.deviceInfo);

// Set mithril's prefix for all route to ""
m.route.prefix = "";

// Import nomenclature functions
import { initializeNomenclature, getUserData as getUserDataUtil, fetchWithAutoRefresh } from './utils.js';

// Cache busting parameter - FORCE CACHE REFRESH
const CACHE_BUST = 'v=8&nocache=' + Date.now();

/**
 * Helper function to validate session with network retry logic.
 * Handles "Failed to fetch" network errors by retrying once.
 * @returns {Promise<{success: boolean, data: object|null, error: string|null}>}
 */
const validateSessionWithRetry = async () => {
    const attemptValidation = async () => {
        const response = await fetchWithAutoRefresh('/api/secure-auth/validate');
        if (!response.ok) {
            return { success: false, data: null, error: 'session_expired' };
        }
        const data = await response.json();
        if (!data.authenticated) {
            return { success: false, data: null, error: 'not_authenticated' };
        }
        return { success: true, data, error: null };
    };

    try {
        return await attemptValidation();
    } catch (error) {
        // Check if it's a network error (Failed to fetch)
        if (error.message === 'Failed to fetch' || error.name === 'TypeError') {
            console.warn('🌐 Network error during session validation, retrying in 1s...', error.message);

            // Retry once after a short delay
            try {
                await new Promise(resolve => setTimeout(resolve, 1000));
                return await attemptValidation();
            } catch (retryError) {
                console.error('🌐 Retry also failed:', retryError.message);
                return { success: false, data: null, error: 'network_error' };
            }
        }

        // For other errors, return failure
        console.error('🔐 Session validation error:', error);
        return { success: false, data: null, error: 'unknown_error' };
    }
};

// Create a resolver function to check authentication for protected routes
const protectedRoute = (viewComponent, title) => {
    let resolvedComponent = viewComponent;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            console.log('🔐 Session validated, user authenticated:', result.data.user);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(viewComponent);

            // If authenticated, render the requested component with Layout
            return Layout;
        },
        render: (vnode) => {
            // Handle the case where onmatch returned null (authentication failed)
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            // Pass the original component and title to Layout
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Block bagian_kredit from subunit-staff-only routes (loan-submissions, disbursements, settlements, prediction, mining)
const subunitStaffRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Allow all roles EXCEPT bagian_kredit
            if (user.role === 'bagian_kredit') {
                console.log('🔐 Bagian Kredit not authorized for this route:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Session validated, user authenticated:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function to check authentication for customer routes (managers and koordinators only)
const customerRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // If user is not a manager or koordinator, redirect to unauthorized page
            if (user.role !== 'manajer' && user.role !== 'koordinator' && user.role !== 'kasir') {
                console.log('🔐 User role not authorized for customer routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Customer route authorized for user:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            // If user is authorized, render the requested component with Layout
            return Layout;
        },
        render: (vnode) => {
            // Handle the case where onmatch returned null (authentication failed)
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            // Pass the original component and title to Layout
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function to check authentication for superuser-only routes
const superuserOnlyRoute = (viewComponent, title) => {
    let resolvedComponent = viewComponent;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // If user is not a superuser, redirect to unauthorized page
            if (user.role !== 'superuser') {
                console.log('🔐 User role not authorized for superuser routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Superuser route authorized for user:', user.username);

            resolvedComponent = await resolveViewComponent(viewComponent);

            // If user is a superuser, render the requested component with Layout
            return Layout;
        },
        render: (vnode) => {
            // Handle the case where onmatch returned null (authentication failed)
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            // Pass the original component and title to Layout
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function for COA reference that differentiates between roles with lazy loading
const coaReferenceRoute = (title) => {
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Get user data and initialize nomenclature
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            // Check role-based access restrictions
            if (user.role === 'manajer') {
                // Only managers can access CoaReferenceManajer.js
                const module = await import('./views/CoaReferenceManajer.js');
                return module.default;
            } else if (user.role === 'superuser' || user.role === 'admin') {
                // Only superusers and admins can access CoaReference.js
                const module = await import('./views/CoaReference.js');
                return module.default;
            } else {
                // koordinator and kasir roles are not authorized
                console.log('🔐 User role not authorized for COA reference:', user.role);
                m.route.set('/unauthorized');
                return null;
            }
        },
        render: function (vnode) {
            // Handle the case where onmatch returned null (authentication failed)
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            // Pass the title to the Layout component and the viewComponent as children
            return m(Layout, { title: title }, m(vnode.tag));
        }
    };
};

// Create a resolver function to check authentication for koordinator-only routes
const koordinatorOnlyRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // If user is not a koordinator, redirect to unauthorized page
            if (user.role !== 'koordinator') {
                console.log('🔐 User role not authorized for koordinator routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Koordinator route authorized for user:', user.username);

            resolvedComponent = await resolveViewComponent(component);

            // If user is a koordinator, render the requested component with Layout
            return Layout;
        },
        render: (vnode) => {
            // Handle the case where onmatch returned null (authentication failed)
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            // Pass the original component and title to Layout
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function to check authentication for manager-only routes
const manajerOnlyRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Allow manajer, superuser, and admin only (NOT bagian_kredit)
            if (user.role !== 'manajer' && user.role !== 'superuser' && user.role !== 'admin') {
                console.log('🔐 User role not authorized for manager routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Manager route authorized for user:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            // Return Layout with component
            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function for bagian_kredit-only routes (loan-approvals and loan-installments)
const bagianKreditOnlyRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Allow bagian_kredit only
            if (user.role !== 'bagian_kredit') {
                console.log('🔐 User role not authorized for bagian kredit routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Bagian Kredit route authorized for user:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            // Return Layout with component
            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Loan Approvals route — allows manajer, superuser, admin, AND bagian_kredit
// Serves LoanApprovals component; role-aware data is returned by the backend
const loanApprovalsRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Allow manajer, superuser, admin, AND bagian_kredit
            if (user.role !== 'manajer' && user.role !== 'superuser' && user.role !== 'admin' && user.role !== 'bagian_kredit') {
                console.log('🔐 User role not authorized for loan approvals route:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Loan approvals route authorized for user:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            // Return Layout with component
            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function to check authentication for strict manager-only routes
const strictlyManajerOnlyRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // STRICTLY allowed for Manajer and Bagian Kredit
            if (user.role !== 'manajer' && user.role !== 'bagian_kredit') {
                console.log('🔐 User role not authorized for strict manager route:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Strict Manager route authorized for user:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            // Return Layout with component
            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function to check authentication for kasir-only routes
const kasirOnlyRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Allow kasir and superuser (for debugging)
            if (user.role !== 'kasir' && user.role !== 'superuser') {
                console.log('🔐 User role not authorized for kasir routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Kasir route authorized for user:', user.username);

            resolvedComponent = await resolveViewComponent(component);

            // Return Layout with component
            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function to check authentication for akuntansi routes
const akuntansiRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Allow akuntansi, manajer, and superuser
            if (user.role !== 'akuntansi' && user.role !== 'manajer' && user.role !== 'superuser') {
                console.log('🔐 User role not authorized for akuntansi routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Akuntansi route authorized for user:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            // Return Layout with component
            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// Create a resolver function to check authentication for accounting journal routes (includes kasir)
const akuntansiJournalRoute = (component, title) => {
    let resolvedComponent = component;
    return {
        onmatch: async () => {
            const result = await validateSessionWithRetry();

            if (!result.success) {
                if (result.error === 'network_error') {
                    console.log('🌐 Network error, redirecting to login');
                } else if (result.error === 'session_expired') {
                    console.log('🔐 Session expired, redirecting to login');
                } else {
                    console.log('🔐 Not authenticated, redirecting to login');
                }
                m.route.set('/login');
                return null;
            }

            const user = result.data.user;

            // Allow akuntansi, manajer, kasir, and superuser
            if (user.role !== 'akuntansi' && user.role !== 'manajer' && user.role !== 'kasir' && user.role !== 'superuser') {
                console.log('🔐 User role not authorized for accounting journal routes:', user.role);
                m.route.set('/unauthorized');
                return null;
            }

            console.log('🔐 Accounting journal route authorized for user:', user.username);

            // Initialize nomenclature system with user's subunit
            try {
                await initializeNomenclature(result.data);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }

            resolvedComponent = await resolveViewComponent(component);

            // Return Layout with component
            return Layout;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title, content: resolvedComponent });
        }
    };
};

// ============================================================================
// Global PWA Setup - Register SW early & capture beforeinstallprompt
// ============================================================================
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
        .then(reg => console.log('[PWA] SW registered globally:', reg.scope))
        .catch(err => console.warn('[PWA] SW registration skipped:', err.message));
}

// Capture beforeinstallprompt early (before any component loads)
window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__pwaInstallPrompt = e;
    console.log('[PWA] beforeinstallprompt captured globally');
});

window.addEventListener('appinstalled', () => {
    window.__pwaInstallPrompt = null;
    console.log('[PWA] App installed');
});

// Define routes
m.route(document.body, "/", {
    // PWA Login Route
    "/pwa/login": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            
            // If already logged in as koordinator, redirect to dashboard
            if (userData.authenticated && userData.role === 'koordinator') {
                m.route.set('/coord-dashboard-mobile');
                return null;
            }
            
            // Import and register service worker for PWA
            if ('serviceWorker' in navigator) {
                try {
                    const registration = await navigator.serviceWorker.register('/sw.js', {
                        scope: '/'
                    });
                    console.log('[PWA] Service Worker registered:', registration.scope);
                } catch (error) {
                    console.error('[PWA] Service Worker registration failed:', error);
                }
            }
            
            return import('./views/PwaLogin.js').then(module => module.default);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return null; // Will redirect
            }
            return m(vnode.tag);
        }
    },
    
    "/dashboard": protectedRoute(Dashboard, "Dashboard"),
    "/akuntansi-dashboard": akuntansiRoute(AkuntansiDashboard, "Dashboard Akuntansi"),
    "/kasir-dashboard": kasirOnlyRoute(KasirDashboard, "Dashboard Kasir"),
    "/customers": customerRoute(Customers, "titles.customers"), // Updated route to use customerRoute
    "/kelompok": customerRoute(Kelompok, "titles.groups"),
    "/coord-customers": koordinatorOnlyRoute(CoordCustomers, "Data Nasabah"), // Add route for koordinator customers view
    "/coord-customers-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile component directly (no Layout)
            // Initialize nomenclature system (silent fail safe)
            try { await initializeNomenclature(userData); } catch (e) { }
            return CoordCustomersMobile;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/backup": superuserOnlyRoute(Backup, "Backup Database"),
    "/subunit-backup": protectedRoute(SubunitBackup, "Backup Data Unit"),
    "/coord-dashboard-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // Keep the original auth/nomenclature flow, but mount the additive swipe hub.
            try { await initializeNomenclature(userData); } catch (e) { }
            return CoordHomeMobile;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-saving-account-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile savings component directly (no Layout)
            // Initialize nomenclature system (silent fail safe)
            try { await initializeNomenclature(userData); } catch (e) { }
            return await resolveViewComponent(CoordSavingAccountMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-loan-installment-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile loan installment component directly (no Layout)
            // Initialize nomenclature system (silent fail safe)
            try { await initializeNomenclature(userData); } catch (e) { }
            return await resolveViewComponent(CoordLoanInstallmentMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-receipts-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile receipts component directly (no Layout)
            // Initialize nomenclature system (silent fail safe)
            try { await initializeNomenclature(userData); } catch (e) { }
            return await resolveViewComponent(CoordReceiptsMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-view-customer-mobile/:id": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile customer view component directly (no Layout)
            // Initialize nomenclature system (silent fail safe)
            try { await initializeNomenclature(userData); } catch (e) { }
            return await resolveViewComponent(CoordViewCustomerMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-add-customer-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile add customer component directly (no Layout)
            // Initialize nomenclature system (silent fail safe)
            try { await initializeNomenclature(userData); } catch (e) { }
            return await resolveViewComponent(CoordAddCustomerMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-edit-customer-mobile/:id": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile edit customer component directly (no Layout)
            // Initialize nomenclature system (silent fail safe)
            try { await initializeNomenclature(userData); } catch (e) { }
            return await resolveViewComponent(CoordEditCustomerMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-pinjaman-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile pinjaman component directly (no Layout)
            return await resolveViewComponent(CoordPinjamanMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-pengajuan-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile pengajuan component directly (no Layout)
            return await resolveViewComponent(CoordPengajuanMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-pencairan-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile pencairan component directly (no Layout)
            return await resolveViewComponent(CoordPencairanMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-settlements-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile settlements component directly (no Layout)
            return await resolveViewComponent(CoordLoanSettlementsMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-customer-portfolio-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            if (userData && userData.role && userData.role.toLowerCase() === 'koordinator') {
                return CoordHomeMobile;
            }
            m.route.set('/unauthorized');
            return null;
        },
        render: (vnode) => m(vnode.tag)
     },
     "/coord-customer-portfolio-detail/:id": {
         onmatch: async () => {
             const userData = await getUserDataUtil();
             if (!userData.authenticated) {
                 m.route.set('/login');
                 return null;
             }
             if (userData.role !== 'koordinator') {
                 m.route.set('/unauthorized');
                 return null;
             }
             return await resolveViewComponent(CoordCustomerPortfolioDetailMobile);
         },
         render: (vnode) => {
             if (vnode === null || vnode.tag === null) {
                 return m(Login);
             }
             return m(vnode.tag);
         }
      },
      "/coord-customer-profile/:id": {
          onmatch: async () => {
              const userData = await getUserDataUtil();
              if (!userData.authenticated) {
                  m.route.set('/login');
                  return null;
              }
              if (userData.role !== 'koordinator') {
                  m.route.set('/unauthorized');
                  return null;
              }
              return await resolveViewComponent(CoordCustomerProfileMobile);
          },
          render: (vnode) => {
              if (vnode === null || vnode.tag === null) {
                  return m(Login);
              }
              return m(vnode.tag);
          }
      },
      "/coord-rekapitulasi-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            return await resolveViewComponent(CoordMobileRekapitulasi);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-rekap-pinjaman-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            return await resolveViewComponent(CoordMobileRekapPinjaman);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-rekap-pinjaman-details/:productId": {
        onmatch: async (attrs) => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            return {
                view: () => m(CoordMobileRekapPinjamanDetails, { productId: attrs.productId })
            };
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-rekap-simpanan-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            return await resolveViewComponent(CoordMobileRekapSimpanan);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-rekap-simpanan-history/:productId/:transactionType": {
        onmatch: async (attrs) => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            return {
                view: () => m(CoordMobileRekapSimpananHistory, { 
                    productId: attrs.productId,
                    transactionType: attrs.transactionType
                })
            };
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-profile-mobile": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            return await resolveViewComponent(CoordProfileMobile);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/coord-savings-withdrawals": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // If user is not a koordinator, redirect to unauthorized page
            if (role !== 'koordinator') {
                m.route.set('/unauthorized');
                return null;
            }

            // If user is a koordinator, render the mobile savings withdrawals component directly (no Layout)
            return await resolveViewComponent(CoordSavingsWithdrawals);
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(vnode.tag);
        }
    },
    "/view-customer/:id": koordinatorOnlyRoute(CoordViewCustomer, "Detail Nasabah"), // Add route for viewing customer details

    "/vulgar": {
        onmatch: () => import('./views/Vulgar.js'),
        render: (vnode) => m(Layout, { title: "API Tool Page" }, m(vnode.tag))
    },
    "/toasttest": {
        onmatch: () => import('./views/ToastTest.js'),
        render: (vnode) => m(Layout, { title: "Toaster Test Page" }, m(vnode.tag))
    },
    "/hashtool": {
        onmatch: () => import('./views/HashTool.js'),
        render: (vnode) => m(Layout, { title: "Password Hash Tool" }, m(vnode.tag))
    },
    // LocalStorageReader route removed - no longer needed with HTTP-only cookies
    "/unitbusiness": {
        onmatch: async () => {
            const userData = await getUserDataUtil();

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            try {
                await initializeNomenclature(userData);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }
            const module = await import('./views/UnitBusiness.js');
            return module.default;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title: "Bisnis Unit Manajemen" }, m(vnode.tag));
        }
    },
    "/unitusaha": {
        onmatch: async () => {
            const userData = await getUserDataUtil();

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            try {
                await initializeNomenclature(userData);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }
            const module = await import('./views/UnitUsaha.js');
            return module.default;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title: "Unit Usaha Manajemen" }, m(vnode.tag));
        }
    },
    // Accounting Module Routes
    "/accounting/posting": akuntansiJournalRoute(PostingJurnal, "Posting Jurnal"),
    "/accounting/general-journal": akuntansiJournalRoute(GeneralJournal, "Jurnal Umum"),
    "/accounting/reports/balance-sheet": akuntansiRoute(BalanceSheet, "Laporan Posisi Keuangan"),
    "/accounting/reports/income-statement": akuntansiRoute(IncomeStatement, "Laporan Perhitungan Hasil Usaha"),
    "/accounting/reports/phu-allocation": manajerOnlyRoute(PerhitunganPHU, "Perhitungan PHU"),
    "/accounting/reports/equity-change": akuntansiRoute(EquityChange, "Laporan Perubahan Ekuitas"),
    "/accounting/reports/cash-flow": akuntansiRoute(CashFlow, "Laporan Arus Kas"),
    "/accounting/reports/calk": akuntansiRoute(CALK, "Catatan atas Laporan Keuangan"),
    "/belanja": protectedRoute(Belanja, "Belanja"),

    "/badanusaha": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            // Check role authorization
            if (role !== 'superuser') {
                m.route.set('/unauthorized');
                return null;
            }

            const module = await import('./views/BadanDanUnitUsaha.js');
            return module.default;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title: "Badan dan Unit Usaha" }, m(vnode.tag));
        }
    },
    "/profile": protectedRoute(Profile, "User Profile"),
    "/manajer": {
        onmatch: async () => {
            const userData = await getUserDataUtil();

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            try {
                await initializeNomenclature(userData);
            } catch (error) {
                console.warn('Failed to initialize nomenclature:', error);
            }
            const module = await import('./views/Manajer.js');
            return module.default;
        },
        render: (vnode) => {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title: "Manajer Management" }, m(vnode.tag));
        }
    },
    "/coareference": coaReferenceRoute("Referensi Bagan Akun Standar"), // Updated CoaReference route
    // Add new routes
    "/officers": protectedRoute(Officers, "Data Pejabat"),
    "/produk": protectedRoute(Produk, "Data Produk"),
    "/umum": protectedRoute(Branches, "Data Cabang"),
    // Add loan-related routes
    "/dbtool": {
        onmatch: () => import('./views/DbTool.js'),
        render: (vnode) => m(Layout, { title: "Database Tool" }, m(vnode.tag))
    },
    "/loan-submissions": subunitStaffRoute(LoanSubmissions, "Pengajuan Pinjaman"),
    "/loan-approvals": loanApprovalsRoute(LoanApprovals, "Persetujuan Pinjaman"),
    "/loan-list": loanApprovalsRoute(DaftarPinjaman, "Daftar Pinjaman"),
    "/loan-disbursements": subunitStaffRoute(LoanDisbursements, "Pencairan Pinjaman"),
    "/loan-installments": {
        onmatch: async () => {
            const userData = await getUserDataUtil();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role === 'koordinator') {
                return await resolveViewComponent(LoanInstallmentsCoordinator);
            } else {
                // Initialize nomenclature system
                try {
                    await initializeNomenclature(userData);
                } catch (error) {
                    console.warn('Failed to initialize nomenclature:', error);
                }
                return await resolveViewComponent(LoanInstallments);
            }
        },
        render: function (vnode) {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title: "titles.loanInstallments" }, m(vnode.tag));
        }
    },
    "/receipts": koordinatorOnlyRoute(Receipts, "Daftar Tanda Terima"),
    "/loan-settlements": subunitStaffRoute(LoanSettlements, "Penyelesaian Pinjaman"),
    "/loan-monitoring": strictlyManajerOnlyRoute(LoanMonitoring, "Monitoring Pinjaman"),
    "/loan-prediction": subunitStaffRoute(LoanPrediction, "Prediksi Kelancaran Pinjaman"),
    "/loan-mining": subunitStaffRoute(LoanMining, "Proses Mining"),
    // Add coordinator management routes for managers
    "/petugas-aktivitas": protectedRoute(CoordinatorAktivitas, "Aktivitas Petugas"),
    "/petugas-setoran": protectedRoute(CoordinatorSetoran, "Setoran Petugas"),
    "/petugas-fund-management": protectedRoute(CoordinatorFundManagement, "Penggantian/Penitipan Dana Petugas"),
    "/bank-deposit-history": protectedRoute(BankDepositHistory, "Riwayat Setoran Bank"),
    "/nomenclature-settings": protectedRoute(NomenclatureSettings, "Pengaturan Terminologi"),
    // Add savings-related routes
    "/savings-list": customerRoute(DaftarSimpanan, "Daftar Simpanan"),
    "/savings-deposits": {
        onmatch: async () => {
            const userData = await getUserData();
            const role = userData.role;

            // Check authentication using cookie-based system
            if (!userData.authenticated) {
                m.route.set('/login');
                return null;
            }

            if (role === 'koordinator') {
                return SavingsDepositsCoordinator;
            } else {
                // Initialize nomenclature system
                try {
                    await initializeNomenclature(userData);
                } catch (error) {
                    console.warn('Failed to initialize nomenclature:', error);
                }
                return SavingsDeposits;
            }
        },
        render: function (vnode) {
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Layout, { title: "Setoran Simpanan" }, m(vnode.tag));
        }
    },
    "/savings-withdrawals": protectedRoute(SavingsWithdrawals, "Penarikan Simpanan"),
    "/savings-interest": protectedRoute(SavingsInterestPayment, "Pembayaran Jasa"),
    "/savings-performance": protectedRoute(SavingsPerformance, "Kinerja Simpanan"),
    "/kinerja/target": protectedRoute(KinerjaTarget, "Target Kinerja"),
    "/kinerja/realisasi": protectedRoute(KinerjaRealisasi, "Realisasi Kinerja"),
    "/loans-performance": protectedRoute(LoansPerformance, "Kinerja Pinjaman"),
    "/new-account": protectedRoute(NewAccount, "Rekening Baru"),
    "/account-list": protectedRoute(AccountList, "Daftar Rekening"),
    "/edit-account/:id": protectedRoute(EditAccount, "Edit Rekening"),
    "/view-account/:id": protectedRoute(ViewAccount, "Detail Rekening"),
    "/login": {
        render: () => m(Login)
    },
    "/forgot-password": {
        render: () => m(ForgotPassword)
    },
    "/reset-password/:token": {
        render: (vnode) => m(ResetPassword, { token: vnode.attrs.token })
    },
    "/": {
        onmatch: async () => {
            try {
                // Check session validity using secure endpoint
                const response = await fetch('/api/secure-auth/validate');

                if (!response.ok) {
                    // If session invalid, show landing page
                    return Landing;
                }

                const data = await response.json();

                if (!data.authenticated) {
                    // If not authenticated, show landing page
                    return Landing;
                }

                console.log('🔐 Root route: user authenticated, redirecting to dashboard');
                // If authenticated, redirect to dashboard
                m.route.set('/dashboard');
                return null;
            } catch (error) {
                console.error('🔐 Root route session validation error:', error);
                // If error, show landing page
                return Landing;
            }
        },
        render: (vnode) => {
            // Handle the case where onmatch returned null (authentication failed)
            if (vnode === null || vnode.tag === null) {
                return m(Login);
            }
            return m(Landing);
        }
    },
    "/unauthorized": {
        onmatch: () => import('./views/Unauthorized.js'),
        render: (vnode) => m(Layout, { title: "Akses Ditolak" }, m(vnode.tag))
    }
});
